import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { ArrowRight, Users } from 'lucide-react';
import { HELD_MEMBERS, type HeldPage } from './queries';

function people(count: number): string {
  return `${count.toLocaleString()} ${count === 1 ? 'person' : 'people'}`;
}

/**
 * The strategy page's one-line view of who is waiting. The list itself lives on its own page
 * (search, filters, paging): there can be thousands, and they don't belong above the settings.
 */
export function HeldSummary({ strategyId }: { strategyId: string }) {
  const { data } = useQuery<{ acquisitionHeldMembers: HeldPage }>(HELD_MEMBERS, {
    variables: { strategyId, limit: 1 },
    fetchPolicy: 'cache-and-network',
  });
  const page = data?.acquisitionHeldMembers;

  return (
    <section
      className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-gray-200 bg-white p-4"
      data-testid="held-summary"
    >
      <div className="flex min-w-0 items-center gap-3">
        <Users className="h-5 w-5 shrink-0 text-gray-500" aria-hidden />
        <div className="min-w-0">
          <h2 className="text-base font-semibold text-gray-900">Waiting to get in</h2>
          <p className="text-sm text-gray-600">
            {page ? `${people(page.total)} waiting · ${page.finished.toLocaleString()} finished their profile` : '…'}
          </p>
        </div>
      </div>
      <Link
        to={`/admin/acquisition/${strategyId}/waiting`}
        className="inline-flex min-h-11 items-center gap-1.5 rounded-md bg-gray-900 px-4 text-sm font-medium text-white hover:bg-gray-800 md:min-h-9"
      >
        Review and let in
        <ArrowRight className="h-4 w-4" aria-hidden />
      </Link>
    </section>
  );
}
